export default function greetingsName(user) {
  return user.attributes
    ? user.attributes.nickname ||
        user.attributes.given_name ||
        user.attributes.family_name ||
        user.attributes.name ||
        user.attributes.email
    : "";
}
